import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive <strong>5 minutes before</strong> your appointment time
    </li>
    <li>
      After your appointment we will send you personalised product recommendations, allowing you to
      shop at your leisure in-store and via{' '}
      <a href="https://www.johnlewis.com" target="_blank" rel="noopener noreferrer">
        johnlewis.com
      </a>
    </li>
    <li>
      We can discuss follow up appointments during our time together, to help guide you from birth
      and beyond
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};

export const RemoteAppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      For your virtual appointment we&apos;ll call you on the number you&apos;ve provided.
      It&apos;ll be useful for you to have access to our website to view the products we&apos;ll
      talk you through.
    </li>
    <li>
      During your appointment, we will spend time understanding your needs and if there are any
      particular brands and products that you would like to know more about
    </li>
    <li>
      We can cover everything from sleeping to travel, feeding, bathing and clothing, or we can
      focus on a specific topic if you prefer
    </li>
    <li>
      This service is to advise you on making the right choices for you and your baby and therefore
      you might want future appointments throughout the different milestones of your child&apos;s
      development
    </li>
    <li>
      We can discuss follow up appointments during our time together, to help guide you from birth
      and beyond
    </li>
    <li>
      After your appointment, you&apos;ll receive a list of the product recommendations we&apos;ve
      discussed, allowing you to shop at your leisure in-store and via{' '}
      <a href="https://www.johnlewis.com" target="_blank" rel="noopener noreferrer">
        johnlewis.com
      </a>
    </li>
    {listItem}
  </ul>
);

RemoteAppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
